'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _actionToReducerMap;

exports.default = reducer;

var _immutable = require('immutable');

var _constants = require('./constants');

var _actions = require('./login-component/actions');

var _actions2 = require('./login-form/actions');

var _utils = require('./login-component/utils');

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * When form was initialized correctly display login form
 * @param {Map} state The state
 * @param {Object} action The action triggering the update
 * @returns {Map} The new state
 */
var fetchStarted = function fetchStarted(state, action) {
    if ((0, _actions.isFetchStartedAction)(action)) {
        return state.set('isFetching', true);
    }
    return state;
};

/**
 * When form was initialized correctly display login form
 * @param {Map} state The state
 * @param {Object} action The action triggering the update
 * @returns {Map} The new state
 */
var fetchFinished = function fetchFinished(state, action) {
    if ((0, _actions.isFetchFinishedAction)(action)) {
        return state.set('isFetching', false);
    }
    return state;
};

/**
 * When form was initialized correctly display login form
 * @param {Map} state The state
 * @param {Object} action The action triggering the update
 * @returns {Map} The new state
 */
var formInitialized = function formInitialized(state, action) {
    if ((0, _actions.isLoginFormInitializedAction)(action)) {
        var formDefaults = (0, _extends3.default)({}, action.dataFromCas.form_defaults);
        // if user has never logged in WH from the current device
        // the "Remember me" checkbox is checked by default
        if (!action.dataFromCas.form_defaults.username) {
            formDefaults = (0, _extends3.default)({}, formDefaults, {
                rememberUsername: true
            });
        }
        return state.set('componentMethodToCall', _constants.CALL_DISPLAY_LOGIN_FORM).set('formDefaults', (0, _immutable.Map)(formDefaults)).set('recoverLoginUrl', action.dataFromCas.recoverLoginUrl);
    }
    return state;
};

/**
 * When form initialization failed display general message
 * @param {Map} state The state
 * @param {Object} action The action triggering the update
 * @returns {Map} The new state
 */
var formInitializationFailed = function formInitializationFailed(state, action) {
    if ((0, _actions.isLoginFormInitialiationFailedAction)(action)) {
        return state.set('componentMethodToCall', _constants.CALL_DISPLAY_MESSAGE).set('message', (0, _immutable.Map)({ title: 'modalErrorInitFormLine1', text: 'modalErrorInitFormLine2' }));
    }
    return state;
};

/**
 * Log in attempt failed - display a message
 * @param {Map} state The state
 * @param {Object} action The action triggering the update
 * @returns {Map} The new state
 */
var userLoginFailed = function userLoginFailed(state, action) {
    if ((0, _actions2.isUserLoginFailedAction)(action)) {
        var message = (0, _utils2.default)(action);
        if (action.error && action.error.placeholders) {
            message.placeholders = action.error.placeholders;
        }
        return state.set('componentMethodToCall', message.whereToDisplay).set('message', (0, _immutable.fromJS)(message));
    }
    return state;
};

/**
 * Props were used - clear them
 * @param {Map} state The state
 * @returns {Map} The new state
 */
var clearProps = function clearProps(state) {
    return state.set('componentMethodToCall', '').set('casData', (0, _immutable.Map)()).set('message', (0, _immutable.Map)({ title: '', text: '' }));
};

/**
 * A map from action types to reducers
 * @type {ActionToReducerMapType}
 */
var actionToReducerMap = (_actionToReducerMap = {}, (0, _defineProperty3.default)(_actionToReducerMap, _constants.FETCH_STARTED, fetchStarted), (0, _defineProperty3.default)(_actionToReducerMap, _constants.FETCH_FINISHED, fetchFinished), (0, _defineProperty3.default)(_actionToReducerMap, _constants.FORM_INITIALIZED, formInitialized), (0, _defineProperty3.default)(_actionToReducerMap, _constants.FORM_INITIALIZATION_FAILED, formInitializationFailed), (0, _defineProperty3.default)(_actionToReducerMap, _constants.USER_LOGIN_FAILED, userLoginFailed), (0, _defineProperty3.default)(_actionToReducerMap, _constants.CLEAR_PROPS, clearProps), _actionToReducerMap);

var defaultState = (0, _immutable.Map)({
    isFetching: false,
    componentMethodToCall: null,
    casData: (0, _immutable.Map)(),
    formDefaults: (0, _immutable.Map)(),
    message: (0, _immutable.Map)({ title: '', text: '' }),
    recoverLoginUrl: null
});

/**
 * Login Form Modal component reducer.
 * @param {Map} state The application state
 * @param {Object} action The action dispatched
 * @returns {Map} The resulting state
 */
function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (actionToReducerMap[action.type]) {
        return actionToReducerMap[action.type](state, action);
    }

    return state;
}
//# sourceMappingURL=reducer.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/login-component/dist/main/reducer.js
// module id = 499
// module chunks = 0